<template>
  <ComponentsLayoutWithNavbar
    id="org-blocking-history"
    main_color="var(--color-main-green)">
    <template #breadcrumbs>
      <Breadcrumbs
        class="pa-0"
        :items="breadcrumbs"/>
    </template>
    <template #main_content>
      <template v-if="loading">
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-10 pr-8"
          :tile="true"
          type="heading"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-3 pr-8"
          :tile="true"
          type="sentences"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-4 main__green mt-5"
          :tile="true"
          type=" table-thead, table-tbody"
          width="100%"/>
      </template>
      <div
        v-else>
        <div class="py-4 text-left h1-headline">
          {{ (item && (item.organizationName || item.usreou) ) || '–' }}
        </div>
        <OrgHistoryTable
          v-for="stopListBlockRow in stopListBlockRows"
          :key="stopListBlockRow.organizationName + stopListBlockRow.stopListBlockRows.length"
          :item="stopListBlockRow"/>
      </div>
    </template>
    <template #nav_bar="{ mini }">
      <div>
        <div
          v-show="!mini"
          class="pl-6 pt-6">
          <div class="h3-headline text-left mb-4">
            {{ $t('StopLists.AboutSupplier') }}
          </div>
          <div
            v-if="!loading"
            class="stop-list-info-rows">
            <KeyValue
              :caption="$t('Purchasing.Status')"
              data-qa="status">
              <StatusChip
                key-name="status_key"
                name="status_name"
                :status="item"/>
            </KeyValue>
            <KeyValue
              :caption="$t('Tenders.EDRPOU')"
              data-qa="usreou"
              :value="item.usreou"/>
            <KeyValue
              :caption="$t('StopLists.LocksNumberInMyOrganization')"
              data-qa="usreou"
              :value="item.blockQantityMyOrganization"/>
            <KeyValue
              :caption="$t('StopLists.LocksNumberOnSite')"
              data-qa="usreou"
              :value="item.blockQantityTotal"/>
          </div>
        </div>
      </div>
    </template>
  </ComponentsLayoutWithNavbar>
</template>
<script>
import KeyValue from 'components/common/KeyValue.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'
import OrgHistoryTable from 'components/stop lists/OrgHistoryTable.vue'
import ComponentsLayoutWithNavbar from 'pages/templates/ComponentsLayoutWithNavbar.vue'

import { StopListFile } from '@/types/commonFile.js'
import { stopListsMixin } from 'mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'orgBlockingHistory',
  mixins: [stopListsMixin],
  data() {
    return {
      item: null,
      loading: true,
      stopListBlockRows: [],
      panel: []
    }
  },
  async created() {
    if (!this.$route.params.usreou && !this.$route.query.id) {
      this.$notice.warning({
        title: this.$t('Common.ErrorTitle'),
        message: this.$t('Common.NotEnoughData'),
      })
      return this.$router.push({name: 'stopLists'})
    }
    await this.$store.dispatch('getStopListByOkpo', {okpo: this.$route.params.usreou, orgId: +this.$route.query.id})
      .then(res => {
        if ( !res ) {
          this.$notice.warning({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('StopLists.YourSearchDidNotMatchAnyCompanies'),
          })
          return this.$router.push({name: 'stopLists'})
        }
        this.stopListBlockRows = [
          {
            organizationName: this.currentOrganization.title,
            stopListBlockRows: res?.stopListBlockRows
          },
          ...(res?.childrenStopLists ?? [])
        ].filter(elem => elem.organizationName && elem.stopListBlockRows?.length)
        this.stopListBlockRows.forEach(elem => {
          elem?.stopListBlockRows?.forEach(it => it.attachments = it?.attachments?.map(att => {
            let doc = new StopListFile(null, att, it.id)
            return doc
          } ))
        })
        this.panel = this.stopListBlockRows.map((el, index) => index)

        this.setStatus(res)
        this.item = res
      })
      .finally(() => {
        this.loading = false
      })
  },
  computed: {
    ...mapGetters({
      currentOrganization: 'getCurrentOrganization',
    }),
    breadcrumbs() {
      return [
        {
          text: this.$t('Menu.StopLists'),
          action: this.close
        },
        {
          text: this.item?.organizationName || this.item?.usreou,
          loading: this.loading
        },
      ]
    },
  },
  components: {
    KeyValue,
    StatusChip,
    Breadcrumbs,
    OrgHistoryTable,
    ComponentsLayoutWithNavbar
  }
}
</script>
<style lang="scss">
#components-layout-org-blocking-history {
  .v-expansion-panel-header {
    min-height: 40px;
    cursor: default;
  }
}
.stop-list-info-rows {
  display: grid;
  gap: 20px;
}
</style>
